import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { of } from 'rxjs'
import { BRAND_MENU } from 'src/app/authentication/model/auth.enum'
import { I18nPipe } from 'src/app/shared/i18n/pipe/i18n.pipe'
import { ApiSearchUtilService } from 'src/app/shared/service/api-search-util/api-search-util.service'
import { ExternalLinkManageService } from 'src/app/shared/service/external-link-manage/external-link-manage.service'
import {
	aldconf,
	fordFmconf,
	fordconf,
	hondaconf,
	jaguarconf,
	landroverconf,
	lynkcoconf,
	omodajaecooconf,
	mgconf,
	smartconf,
	suzukiconf,
	fordfleetmanagementconf
} from 'src/environments/environment'
import { SubSink } from 'subsink'

const links = [
	{
		id: 1,
		link: '/',
		description: 'general_info',
	},
	{
		id: 2,
		link: '/',
		description: 'corporate_governance',
	},
	{
		id: 3,
		link: '/',
		description: 'ald_automotive',
	},
	{
		id: 4,
		link: '/',
		description: 'societe_generale',
	},
	{
		id: 5,
		link: '/',
		description: 'privacy',
	},
]

@Component({
	selector: 'ald-sub-footer',
	templateUrl: './sub-footer.component.html',
	styleUrls: ['./sub-footer.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		I18nPipe
	]
})
export class SubFooterComponent implements OnInit {
	subFooterLinks = links
	year: number
	certSign = ''
	basePath = window.location.hostname
	private subs = new SubSink()
	constructor(private linkManager: ExternalLinkManageService, private apiSearchUtilService: ApiSearchUtilService) {}

	ngOnInit(): void {
		const date = new Date()
		this.year = date.getFullYear()
	}

	getMenuLabelStartingFromCaptive(): BRAND_MENU {
		switch (this.basePath) {
			case this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement'):
				this.getCaptiveLinks()
				return BRAND_MENU.FFM_FORD
			case this.apiSearchUtilService.findTerm(this.basePath, 'ford'):
				this.getCaptiveLinks()
				return BRAND_MENU.FORD
			case this.apiSearchUtilService.findTerm(this.basePath, 'honda'):
				return BRAND_MENU.HONDA
			case this.apiSearchUtilService.findTerm(this.basePath, 'suzuki'):
				this.getCaptiveLinks()
				return BRAND_MENU.SUZUKI
			case this.apiSearchUtilService.findTerm(this.basePath, 'landrover'):
				this.getCaptiveLinks()
				return BRAND_MENU.LAND_ROVER
			case this.apiSearchUtilService.findTerm(this.basePath, 'jaguar'):
				this.getCaptiveLinks()
				return BRAND_MENU.JAGUAR
			case this.apiSearchUtilService.findTerm(this.basePath, 'lynkco'):
				this.getCaptiveLinks()
				return BRAND_MENU.LYNKCO
			case this.apiSearchUtilService.findTerm(this.basePath, 'smart'):
				this.getCaptiveLinks()
				return BRAND_MENU.SMART
			case this.apiSearchUtilService.findTerm(this.basePath, 'omodajaecoo'):
				this.getCaptiveLinks()
				return BRAND_MENU.OMODA_JAECOO
			case this.apiSearchUtilService.findTerm(this.basePath, 'mg'):
				this.getCaptiveLinks()
				return BRAND_MENU.MG
			case this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement'):
				this.getCaptiveLinks()
				return BRAND_MENU.FFM
			default:
				this.getCaptiveLinks(true)
				this.subFooterLinks = links
				return BRAND_MENU.MY_AYVENS
		}
	}

	getCaptiveLinks(isAld?: boolean): void {
		this.subFooterLinks = !!!isAld
			? this.apiSearchUtilService.removeElementFromArray(this.subFooterLinks, 'ald_automotive')
			: this.subFooterLinks
		this.subs.add(
			this.getConfiguration().subscribe((conf: any) => {
				this.subFooterLinks.forEach((element) => {
					switch (element.description) {
						case 'general_info': {
							element.link = conf.general_info
							break
						}
						case 'corporate_governance': {
							element.link = conf.corporate_governance
							break
						}
						case 'ald_automotive': {
							element.link = conf.ald_automotive
							break
						}
						case 'societe_generale': {
							element.link = conf.societe_generale
							break
						}
						case 'privacy': {
							element.link = conf.privacy
							break
						}
					}
				})
			})
		)
	}

	openLink(url): void {
		this.linkManager.openLink(url)
	}

	disableIfNotMyAld(): boolean {
		return this.apiSearchUtilService.findTerm(this.basePath, 'ald')
	}

	getConfiguration(): any {
		switch (this.basePath) {
			case this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement'):
				return of(fordFmconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'ford'):
				return of(fordconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'ald'):
				return of(aldconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'suzuki'):
				return of(suzukiconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'honda'):
				return of(hondaconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'landrover'):
				return of(landroverconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'jaguar'):
				return of(jaguarconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'lynkco'):
				return of(lynkcoconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'smart'):
				return of(smartconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'omodajaecoo'):
				return of(omodajaecooconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'mg'):
				return of(mgconf)
			case this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement'):
				return of(fordfleetmanagementconf)
			default:
				return of(aldconf)
		}
	}
}
